import { log } from './log';

const pixelsDataEnrichmentTimeOutMs = 1000;

export const pixelsDataEnrichment = async (
  mediaId: string,
  domain: string = ''
): Promise<{ pixels_data: string; pixels_segments: string }> => {
  const value = await Promise.race<{ pixels_data: string; pixels_segments: string }>([
    new Promise(resolve => setTimeout(resolve, pixelsDataEnrichmentTimeOutMs, { pixels_data: 'timeout' })),
    new Promise(resolve => PixelsDataEnrichmentWithResolve(resolve, mediaId, domain)),
  ]);
  return value;
};

const PixelsDataEnrichmentWithResolve = async (resolve: any, mediaId: string, domain: string): Promise<void> => {
  let base = 'https://video-intel.pixels.ai';
  if (/localhost/.test(window.location.href)) {
    base = 'http://localhost:3000/video-player/video-intel';
  } else if (/pub-dev.pixels.ai/.test(window.location.href)) {
    base = 'https://video-intel-dev.pixels.ai';
  }
  const endpoint = `${base}?mediaid=${mediaId}&domain=${domain}`;
  const value = await fetch(endpoint)
    .then(response => response.json())
    .catch(ex => {
      log('pixels', 'pixelsDataEnrichment', ex);
      return null;
    });
  log('pixels', 'pixelsDataEnrichment', endpoint, value);
  resolve({ pixels_data: value?.pixels_data_enrichment, pixels_segments: value?.pixels_segments });
};
